import Vue from 'vue'
import Router from 'vue-router'
import store from './store';

Vue.use(Router)

const router = new Router({
    routes: [
        {
            path: '/',
            name: '生活繳費',
            component: () => import( './views/Home.vue'),
            meta: {
                headerType: 'gray',
            }
        },
        {
            path: '/familyArea',
            name: '親子專區',
            component: () => import( './views/FamilyArea.vue'),
            meta: {
                headerType: 'gray',
            }
        },
        {
            path: '/share',
            name: '邀請朋友一起賺回饋金',
            component: () => import( './views/other/Share.vue'),
            meta: {
                headerType: 'white',
            }
        },
        {
            path: '/fundManagement',
            name: '基金理財',
            component: () => import( './views/other/FundManagement.vue'),
            meta: {
                headerType: 'gray',
            }
        },
        {
            path: '/UUPONEvent',
            name: '悠遊付消費紀錄授權',
            component: () => import( './views/other/UUPONEvent.vue'),
            meta: {
                headerType: 'white',
            }
        },
        {
            path: '/insurance',
            name: '保險專區',
            component: () => import( './views/other/Insurance.vue'),
            meta: {
                headerType: 'gray',
            }
        },
        {
            path: '/Error',
            name: '錯誤頁面',
            component: () => import( './views/Error.vue'),
            meta: {
                headerType: 'gray',
            }
        },
        {
            path: '/checkPayInformation',
            name: '請確認付款資訊',
            component: () => import( './views/CheckPayInformation.vue'),
            meta: {
                headerType: 'gray',
            }
        },
        {
            path: '/goPay',
            name: '待繳帳單',
            component: () => import( './views/GoPay.vue'),
            meta: {
                headerType: 'gray',
            }
        },
        {
            path: '/taipeiWaterFee',
            name: '臺北市自來水費',
            component: () => import( './views/waterFee/TaipeiWaterFee.vue'),
            meta: {
                headerType: 'white',
            }
        },
        {
            path: '/taiwanWaterFee',
            name: '台灣自來水費',
            component: () => import( './views/waterFee/TaiwanWaterFee.vue'),
            meta: {
                headerType: 'white',
            }
        },
        {
            path: '/medicalFee',
            name: '台北市聯合醫院醫療費',
            component: () => import( './views/medicalFee/MedicalFeeList.vue'),
            meta: {
                headerType: 'white',
            }
        },
        {
            path: '/roadsideParking',
            name: '路邊臨時停車費',
            component: () => import( './views/roadsideParking/RoadsideParkingList.vue'),
            meta: {
                headerType: 'white',
            }
        },
        {
            path: '/taipeiCityTuitionFee',
            name: '台北市學雜費',
            component: () => import( './views/tuitionFee/TuitionFeeList.vue'),
            meta: {
                headerType: 'white',
            }
        },
        {
            path: '/newTaipeiCityTuitionFee',
            name: '新北市學雜費',
            component: () => import( './views/tuitionFee/NewTaipeiCitySchool.vue'),
            meta: {
                headerType: 'white',
            }
        },
        {
            path: '/tuitionFee/newTaipeiCityChildBindingAddList',
            name: '親子綁定',
            component: () => import( './views/tuitionFee/NewTaipeiCityChildBindingAddList.vue'),
            meta: {
                headerType: 'white',
            }
        },
        {
            path: '/otherTuitionFee',
            name: '學雜費',
            component: () => import( './views/tuitionFee/OtherSchool.vue'),
            meta: {
                headerType: 'white',
            }
        },
        {
            path: '/tuitionFee/childBindingAddList',
            name: '親子綁定',
            component: () => import( './views/tuitionFee/ChildBindingAddList.vue'),
            meta: {
                headerType: 'white',
            }
        },
        {
            path: '/tax',
            name: '台北市地方稅',
            component: () => import( './views/tax/Tax.vue'),
            meta: {
                headerType: 'white',
            }
        },
        {
            path: '/tuition/termsOfPolicy',
            name: '同意條款',
            component: () => import( './views/tuitionFee/TermsOfPolicy.vue'),
            meta: {
                headerType: 'gray',
            }
        },
        {
            path: '/tuition/newTaipeiCityTermsOfPolicy',
            name: '新北市親子綁定同意條款',
            component: () => import( './views/tuitionFee/NewTaipeiCityTermsOfPolicy.vue'),
            meta: {
                headerType: 'gray',
            }
        },
        {
            path: '/carPark',
            name: '停車場自動扣繳、路邊及停車場月票',
            component: () => import( './views/carPark/CarParkList.vue'),
            meta: {
                headerType: 'white',
            }
        },
        {
            path: '/carPark/addCarNumber',
            name: '新增約定車牌',
            component: () => import( './views/carPark/AddCarNumber.vue'),
            meta: {
                headerType: 'white',
            }
        },
        {
            path: '/carPark/termsOfPolicy',
            name: '同意條款',
            component: () => import( './views/carPark/TermsOfPolicy.vue'),
            meta: {
                headerType: 'gray',
            }
        },
        {
            path: '/bindItemList',
            name: '待繳清單',
            component: () => import( './views/PaymentList.vue'),
            meta: {
                headerType: 'gray',
            }
        },
        {
            path: '/payment-add-item',
            name: '路邊臨時停車費綁定',
            component: () => import( './views/PaymentAddItem.vue'),
            meta: {
                headerType: 'white',
            }
        },
        {
            path: '/electronicFee',
            name: '電費',
            component: () => import( './views/electronicFee/NewElectronic.vue'),
            meta: {
                headerType: 'white',
            }
        },
        {
            path: '/gasFee',
            name: '瓦斯費',
            component: () => import( './views/gasFee/Gas.vue'),
            meta: {
                headerType: 'white',
            }
        },
        {
            path: '/tvFee',
            name: '有線電視費',
            component: () => import( './views/tvFee/TvFee.vue'),
            meta: {
                headerType: 'white',
            }
        },
        {
            path: '/publicBuildingFee',
            name: '臺北市國/社宅租⾦維管費',
            component: () => import( './views/publicBuildingFee/PublicBuilding.vue'),
            meta: {
                headerType: 'white',
            }
        },
        {
            path: '/publicBuildingBill',
            name: '臺北市國/社宅租⾦維管費',
            component: () => import( './views/publicBuildingFee/BillNumber.vue'),
            meta: {
                headerType: 'white',
            }
        },
        {
            path: '/bindHouseFee',
            name: '社宅住戶身分綁定',
            component: () => import( './views/publicBuildingFee/BindHouseFee.vue'),
            meta: {
                headerType: 'white',
            }
        },
        {
            path: '/publicBuildingFee/HouseTermsOfPolicy',
            name: '同意條款',
            component: () => import( './views/publicBuildingFee/HouseTermsOfPolicy.vue'),
            meta: {
                headerType: 'gray',
            }
        },
        {
            path: '/cashback2021',
            name: '振興方案',
            component: () => import( './views/cashback2021/Cashback.vue'),
            meta: {
                headerType: 'gray',
            }
        },
        {
            path: '/newYearEvent2022',
            name: '虎虎生風',
            component: () => import( './views/newyear2022/NewYearEvent2022.vue'),
            meta: {
                headerType: 'gray',
            }
        },
        {
            path: '/carFuelFee',
            name: '汽機車燃料使用費',
            component: () => import( './views/carFuelFee/CarFuelFee.vue'),
            meta: {
                headerType: 'gray',
            }
        },
        {
            path: '/carFine',
            name: '汽燃費逾期繳納罰款',
            component: () => import( './views/carFuelFee/CarFine.vue'),
            meta: {
                headerType: 'gray',
            }
        },
        {
            path: '/hostel',
            name: '民宿',
            component: () => import( './views/hostel/Hostel.vue'),
            meta: {
                headerType: 'gray',
            }
        },
        {
            path: '/kbroFee',
            name: '選擇有線電視公司',
            component: () => import( './views/tvFee/KbroFee.vue'),
            meta: {
                headerType: 'gray',
            }
        },
        {
            path: '/kbroFeeStep2',
            name: '',
            component: () => import( './views/tvFee/KbroFeeStep2.vue'),
            meta: {
                headerType: 'gray',
            }
        },
        {
            path: '/TMS',
            name: '全鋒登錄活動',
            component: () => import( './views/other/TMS.vue'),
            meta: {
                headerType: 'gray',
            }
        },
        {            
            path: '/travel',
            name: '旅遊專區',
            component: () => import( './views/travel/Travel.vue'),
            meta: {
                headerType: 'gray',
            }
        },
        {
            path: '/fund',
            name: '基金申購',
            component: () => import( './views/other/FundManagement.vue'),
            meta: {
                headerType: 'gray',
            }
        },
        {
            path: '/telcomFee/CHT',
            name: '中華電信',
            component: () => import( './views/telcomFee/TelcomFeeCht.vue'),
            meta: {
                headerType: 'white',
            }
        },
        {
            path: '/parkingFee/bind',
            name: '申請自動扣繳',
            component: () => import( './views/roadsideParking/BindingRoadsideParking.vue'),
            meta: {
                headerType: 'white',
            }
        },
        {
            path: '/parkingFee/supportBindingCity',
            name: '路邊停車費自動扣繳支援區域',
            component: () => import( './views/roadsideParking/BindingRoadsideParkingCityList.vue'),
            meta: {
                headerType: 'white',
            }
        },
        {
            path: '/healthyInsurance',
            name: '健保費',
            component: () => import( './views/healthyInsuranceFee/HealthyInsurance.vue'),
            meta: {
                headerType: 'white',
            }
        },
    ]
});

window.popStateDetected = false
window.addEventListener('popstate', () => {
  window.popStateDetected = true
})


router.beforeEach((to, from, next) => {
    const isBackButton = window.popStateDetected
    window.popStateDetected = false
    if (isBackButton && (store.getters.loading || store.getters.lockBack)) {
      next(false) 
      console.log('back button detected, aborting navigation')
      return ''
    }

    if (to.path === '/test' ) {
        next();
    }
    if (to.query.k && store.getters.sessionKey === null) {
        store.dispatch('setSession', {sessionKey: to.query.k, sessionToken: to.query.p});
        if (to.query.tuition_payment) {
            store.dispatch('setSession', {sessionKey: to.query.k, sessionToken: to.query.p, sessionTuitionPayment: to.query.tuition_payment});
        }
    }
    if (to.path === '/carPark' || to.path === '/taipeiCityTuitionFee') {
        if (to.query.k) {
            next();
        } else if (store.getters.sessionKey === null || store.getters.sessionKey === "null" || store.getters.sessionToken === null || store.getters.sessionToken === "null") {
            store.dispatch('sentApp', {
                action: "sessionIsNull",
                payload: {}
            });
            next(false);
        } else {
            next();
        }

    } else if ((to.path !== '/' && 
        to.path !== '/share' && 
        to.path !== '/fundManagement' &&
        to.path !== '/familyArea' &&
        to.path !== '/cashback2021' && 
        to.path !== '/newYearEvent2022' && 
        to.path !== '/TMS' && 
        to.path !== '/insurance' &&
        to.path !== '/hostel' &&  
        to.path !== '/travel' &&
        to.path !== '/fund') && 
        (store.getters.sessionKey === null || 
            store.getters.sessionKey === "null" || 
            store.getters.sessionToken === null || 
            store.getters.sessionToken === "null")) {
        store.dispatch('sentApp', {
            action: "sessionIsNull",
            payload: {}
        });
        next(false);
    } else {
        next();
    }
    console.log({k: to.query.k, p: to.query.p})
});

export default router;
